import React, { useState, useEffect } from 'react';
import { CheckCircle2, XCircle, Info, AlertTriangle } from 'lucide-react';

// Global variable to hold the addToast function reference
let addToastFn = () => {};

export const toast = {
  success: (message) => addToastFn(message, 'success'),
  error: (message) => addToastFn(message, 'error'),
  info: (message) => addToastFn(message, 'info'),
  warning: (message) => addToastFn(message, 'warning'),
};

export const CustomToaster = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    // Expose the internal state updater to the global function
    addToastFn = (message, type) => {
      const id = Date.now() + Math.random();
      setToasts((prev) => [...prev, { id, message, type }]);
      
      // Auto dismiss
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 5000);
    };
  }, []);

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-3 pointer-events-none">
      {toasts.map((t) => (
        <div 
          key={t.id} 
          className={`pointer-events-auto flex items-center gap-3 px-5 py-4 rounded-xl shadow-xl border transition-all duration-300 animate-fade-in-up ${
            t.type === 'success' 
              ? 'bg-green-50 border-green-200 text-green-900' 
              : t.type === 'error'
                ? 'bg-red-50 border-red-200 text-red-900'
                : t.type === 'warning'
                  ? 'bg-amber-50 border-amber-200 text-amber-900'
                  : 'bg-blue-50 border-blue-200 text-blue-900'
          }`}
        >
          {t.type === 'success' ? (
            <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0" />
          ) : t.type === 'error' ? (
            <XCircle className="w-5 h-5 text-red-600 shrink-0" />
          ) : t.type === 'warning' ? (
            <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0" />
          ) : (
            <Info className="w-5 h-5 text-blue-600 shrink-0" />
          )}
          <p className="font-medium text-sm">{t.message}</p>
        </div>
      ))}
    </div>
  );
};
